export default __webpack_public_path__ + "static/media/volume.72dd3e72.svg";